import React from 'react'
import AddHomevisit from '../AddHomevisit'
import {Link} from "react-router-dom";

import petcare from "../images/pet care photo.jpg";
import Header from '../inc/Header';


function UploadPrescription() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
         <div className='petprescriptionupload'>
                <div className="album py-1 ">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>

                                <li className="breadcrumb-item active" aria-current="page">Upload Prescription</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
         <div className='prescription'>
        <div className="album py-0">
          <div className="container">
                    <div className="row">

                        <div className="col-md-6 mt-2">
            <AddHomevisit/>
            </div>
             <div className="col-md-6 mt-2">
              <br/>
                                            <img src={petcare} className="card-img-top" alt="petcare"/>

             </div>
            </div>
          </div>
        </div>
         <br/>
      <br/>
      </div>
     
    </div>
  )
}

export default UploadPrescription